import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/quickpick/good-trainers/summary`;

export const GoodTrainersCard = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    axios.get(API, { withCredentials: true }).then((r) => setS(r.data)).catch(() => setS({ error: true }));
  }, []);
  const when = s?.ingested_at ? new Date(s.ingested_at).toLocaleString('en-US', { timeZone: 'America/New_York' }) + ' ET' : 'never';
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4 mb-4" data-testid="good-trainers-card">
      <h2 className="text-lg font-semibold text-white">Good Trainers</h2>
      <p className="text-slate-400 text-sm mb-2">
        Replaced in full whenever <code>emGoodTrainer.csv</code> lands in the source FTP folder. Used by Auto Win-Bet Strategy C.
      </p>
      {s?.error ? <p className="text-rose-400 text-sm" data-testid="good-trainers-error">Could not load.</p> : (
        <div className="flex flex-wrap gap-6 text-sm">
          <div><span className="text-slate-500">Trainers: </span><span className="text-white font-mono" data-testid="good-trainers-count">{s ? s.count : '…'}</span></div>
          <div><span className="text-slate-500">Meet Strategy C rule: </span><span className="text-orange-400 font-mono" data-testid="good-trainers-subset-count">{s ? s.subset_count : '…'}</span></div>
          <div><span className="text-slate-500">Last ingested: </span><span className="text-slate-200" data-testid="good-trainers-ingested">{s ? when : '…'}</span></div>
          {s?.source && <div><span className="text-slate-500">Source: </span><span className="text-slate-400 font-mono text-xs" data-testid="good-trainers-source">{s.source}</span></div>}
        </div>
      )}
      {s?.subset_rule && (
        <p className="text-xs text-slate-500 mt-2" data-testid="good-trainers-subset-rule">
          Strategy C subset rule (trainer exacta rates): <code className="text-slate-300">{s.subset_rule}</code>
        </p>
      )}
    </div>
  );
};
